import PropTypes from 'prop-types';
import unitType from './unit.js';

const {
  arrayOf,
  bool,
  node,
  number,
  oneOf,
  shape,
  string,
  func
} = PropTypes;
const contentType = {
  labels: shape({
    completed: string.isRequired,
    currency: string,
    due: string,
    points: string.isRequired,
    preview: string,
    previewTooltip: string,
    progress: string.isRequired,
    registerNow: string,
    markAsComplete: string,
    updated: string.isRequired,
    hideNUnits: string,
    showNUnits: string,
    hideNSteps: string,
    showNSteps: string,
    unitCompleted: string,
    unitIncomplete: string
  }).isRequired,
  content: shape({
    apiName: string,
    color: string,
    description: string.isRequired,
    descriptionHighlights: arrayOf(shape({
      length: number.isRequired,
      offset: number.isRequired
    })),
    image: string.isRequired,
    path: string,
    title: string.isRequired,
    titleHighlights: arrayOf(shape({
      length: number.isRequired,
      offset: number.isRequired
    })),
    subTitle: string.isRequired,
    type: oneOf(["trail", "module", "project", "trailmix", "customstep", "superbadge", "credential"]).isRequired,
    estimatedTime: string,
    unitCount: number,
    private: bool,
    updatedAt: string,
    points: string,
    preview: shape({
      namespace: string.isRequired,
      releasedAt: string.isRequired,
      updatedAt: string.isRequired
    }),
    trailmix: shape({
      author: shape({
        name: string.isRequired,
        path: string.isRequired
      }).isRequired
    }),
    manualCompletion: bool
  }).isRequired,
  user: shape({
    completedCount: number,
    estimatedTime: string,
    finishedAt: string,
    assignment: shape({
      dueAt: string.isRequired
    }),
    authenticated: bool
  }),
  credential: shape({
    registered: bool.isRequired
  }),
  buttons: arrayOf(node),
  actions: arrayOf(node),
  units: arrayOf(shape(unitType)),
  unitsInitiallyExpanded: bool,
  eventHandlers: shape({
    completeCustomStepHandler: func,
    titleClickHandler: func,
    iconClickHandler: func
  })
};
const defaultContentType = {
  unitsInitiallyExpanded: false,
  eventHandlers: {},
  user: null
};
var contentType$1 = contentType;

export { contentType$1 as default, defaultContentType };
